import { computed, ref } from 'vue';
import api from '@core/services/api/_api';
import CustomerRecord from '@core/classes/Customer/CustomerRecord';
import { defineStore } from 'pinia';

export const useBusinessStore = defineStore('business', () => {
	// State
	const business = ref<CustomerRecord>(null);

	// Getter
	const getBusiness = computed(() => business.value);

	// Actions
	const getBusinessInformationFromBackend = async (id: string) => {
		try {
			const response = await api.customerPortal.getBusinessInformation(id);
			if (response && response?.status === 200 && response.data) {
				setBusiness(response.data.payload);
			}
		} catch (error) {
			console.error(error, 'Error retrieving Business information');
			clearBusiness();
		}
	};

	const clearBusiness = () => {
		business.value = null;
	};

	const setBusiness = (newBusiness: CustomerRecord) => {
		business.value = newBusiness;
	};

	const getBusinessFormData = computed(() => {
		if (!business.value) return null;

		return {
			legalName: business.value.businessInfo.legalName ?? '',
			entityType: business.value.businessInfo.entityType ?? null,
			phoneNumber: business.value.businessInfo.phoneNumber ?? '',
			businessStartDate: business.value.businessInfo.businessStartDate ?? '',
		};
	});

	return {
		business,
		getBusinessInformationFromBackend,
		getBusiness,
		getBusinessFormData,
		clearBusiness,
		setBusiness,
	};
});
